module.exports = __webpack_public_path__ + "img/or_no.b90949f8.png";